import React, { useEffect } from 'react';

import { Input, Form, Modal } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';

import IBaseComponentProps from '@components/base-component-props';

import { exception } from '@extensions/notification';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { IWaypointHeader } from '@entities/waypoint-header';

interface IWaypointHeaderProps extends IBaseComponentProps {
    id: string | undefined;
    onSave: () => void;
    onCancel: () => void;
    api: NotificationInstance;
}

const WaypointHeader = (props: IWaypointHeaderProps) => {
    const { id, api, serverFetch, onSave, onCancel } = props;

    const [form] = Form.useForm();

    const d = useAppDispatch();

    useEffect(() => {
        if (!id) return;

        serverFetch(`waypointheaders/${id}`, { method: 'GET' })
            .then((data: IWaypointHeader) => {
                form.setFieldValue('id', data.id);
                form.setFieldValue('name', data.name);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка получения маршрута', ex, () => d(userLoaded(undefined)));
            });
    }, []);

    const onFinish = (entity: IWaypointHeader) => {
        serverFetch(`waypointheaders`, { method: id ? 'PUT' : 'POST', bodyData: entity })
            .then(() => {
                onSave();
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка сохранения маршрута', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <Modal
            destroyOnHidden={true}
            width={500}
            title={id ? 'Изменить маршрут' : 'Добавить маршрут'}
            open={true}
            okText='ОК'
            onOk={() => {
                form.submit();
            }}
            onCancel={() => onCancel()}
        >
            <Form colon={false} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} onFinish={onFinish} style={{ marginTop: 20 }} form={form}>
                <Form.Item hidden name='id'>
                    <Input />
                </Form.Item>
                <Form.Item label='Название' name='name'>
                    <Input autoFocus />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default WaypointHeader;
